export const fadeInRight = {
  hidden: {
    opacity: 0,
    x: 20,
    transition: {
      duration: 0.25,
      type: 'spring',
      damping: 25,
      stiffness: 500,
    },
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.25,
      type: 'spring',
      damping: 25,
      stiffness: 500,
    },
  },
};
